import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function ProblemSolution() {
  return <section className="py-16 border-t border-black text-center" data-id="element-195">
      <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-196">
        <div className="bg-red-900/30 p-6 rounded-lg shadow-lg" data-id="element-197">
          <h2 className="text-2xl font-bold mb-6 flex items-center justify-center" data-id="element-198">
            <XCircleIcon className="h-8 w-8 text-red-500 mr-2" data-id="element-199" />
            El Verdadero Problema
          </h2>
          <p className="text-lg mb-6" data-id="element-200">
            <span className="font-bold text-red-400" data-id="element-201">
              No es tu producto. No son tus ads.
            </span>{' '}
            El verdadero culpable es que tu copy, tus páginas y tus emails no
            persuaden.
          </p>
          <p className="text-lg" data-id="element-202">
            Cada dólar invertido en tráfico se pierde si el mensaje no conecta
            emocionalmente.
          </p>
          <div className="mt-6 p-4 bg-red-950/50 rounded" data-id="element-203">
            <h3 className="font-bold mb-2" data-id="element-204">
              Síntomas que indican este problema:
            </h3>
            <ul className="space-y-2" data-id="element-205">
              <li data-id="element-206">• Alto costo por adquisición</li>
              <li data-id="element-207">• Baja tasa de conversión</li>
              <li data-id="element-208">• Visitantes que abandonan sin comprar</li>
              <li data-id="element-209">• Resultados impredecibles en cada campaña</li>
            </ul>
          </div>
        </div>
        <div className="bg-green-900/30 p-6 rounded-lg shadow-lg" data-id="element-210">
          <h2 className="text-2xl font-bold mb-6 flex items-center justify-center" data-id="element-211">
            <CheckCircleIcon className="h-8 w-8 text-green-500 mr-2" data-id="element-212" />
            La Solución Lógica
          </h2>
          <p className="text-lg mb-6" data-id="element-213">
            El camino es claro:{' '}
            <span className="font-bold text-green-400" data-id="element-214">
              Usar los prompts exactos y frameworks probados
            </span>{' '}
            por marcas de 8 y 9 cifras para que tus VSLs, páginas y funnels
            vendan casi automáticamente.
          </p>
          <p className="text-lg mb-6" data-id="element-215">
            Eso es lo que aprenderás dentro del{' '}
            <span className="font-bold" data-id="element-216">
              AI Persuasion Bootcamp – El Sistema Conversión Instantánea.
            </span>
          </p>
          <div className="mt-6 p-4 bg-green-950/50 rounded" data-id="element-217">
            <h3 className="font-bold mb-2" data-id="element-218">Resultados que obtendrás:</h3>
            <ul className="space-y-2" data-id="element-219">
              <li data-id="element-220">• Funnels que convierten desde el día 1</li>
              <li data-id="element-221">• Copys persuasivos creados en minutos, no semanas</li>
              <li data-id="element-222">• Independencia de agencias y freelancers costosos</li>
              <li data-id="element-223">• Campañas predecibles y escalables</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}